// extracted by mini-css-extract-plugin
export default {"modalWrapper":"FwzYU","opened":"KDPw0","modal":"tCiyJ","header":"iqMHo","content":"yCrZN"};